<template>
  <div>
    <div class="article-block d-column">
      <div class="article-list">
        <div class="module j-flex weight">
          <div v-if="currPrograma != ''" class="fs-xl module-title">
            {{ currPrograma }}
          </div>
          <div v-else class="fs-xl module-title">
            {{ title }}
          </div>
        </div>
      </div>
      <div v-if="title == '社团机构'">
        <div class="person">
          <div
            class="person-img"
            @click="clubInfo(item)"
            v-for="item in clubList"
            :key="item.associationId"
          >
            <img
              :src="getClubImg(item.path)"
              @error="headError"
              style="border-radius: 50%; border: 1px solid #ededed"
            />
            <div class="img-name">{{ item.associationName }}</div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="person">
          <div
            class="person-img"
            @click="venueInfo(item)"
            v-for="item in clubList"
            :key="item.associationId"
          >
            <img
              :src="getClubImg(item.coverFile.path)"
              @error="headError"
              style="border-radius: 50%; border: 1px solid #ededed"
            />
            <div class="img-name">{{ item.venueName }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getAllClub } from '@/api/api'
import { getVenueList, getVenueInfo } from '@/api/api-venue'
export default {
  props: [
    'asideTitle',
    'title',
    'currPrograma',
    'currPath',
    'listIndex',
    'listChildIndex',
  ],
  data() {
    return {
      clubList: [],
      console: '',
    }
  },
  created() {
    if (this.title == '场馆介绍' || this.currPrograma == '场馆介绍') {
      this.getVenueLists()
    } else {
      this.getClub()
    }
  },
  computed: {
    getClubImg() {
      return function (img) {
        if (img == null || img == '') {
          return require('@/assets/img/clubdefault.png')
        } else {
          return img
        }
      }
    },
  },
  methods: {
    headError(e) {
      e.target.src = require('@/assets/img/clubdefault.png')
    },
    getVenueLists() {
      getVenueList().then((res) => {
        if (res.data.statusCode == 1) {
          this.clubList = res.data.obj
        }
      })
    },
    getClub() {
      getAllClub().then((res) => {
        if (res.data.statusCode == 1) {
          this.clubList = res.data.obj
        }
      })
    },
    clubInfo(item) {
      this.$router.push({
        path: '/clubInfo',
        query: {
          one: this.asideTitle,
          two: '社团详情',
          three: this.currPrograma,
          path: this.currPath,
          path1: '/group',
          keepalive: this.listIndex,
          keepchild: this.listChildIndex,
          id: item.associationId,
        },
      })
    },
    venueInfo(item) {
      getVenueInfo(item.venueId).then((res) => {
        if (res.data.statusCode == 1) {
          this.console = res
        }
      })
      this.$router.push({
        path: '/article',
        query: {
          one: this.asideTitle,
          two: '场馆介绍',
          three: this.currPrograma,
          path: this.currPath,
          path1: '/stadium',
          keepalive: 0,
          keepchild: 0,
          articleId: item.uuid,
        },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../../assets/css/main.scss';
table,
table tr th,
table tr td {
  border: 1px solid #d1d1d1;
}
table {
  border-collapse: collapse;
  padding: 2px;
}
.td-1 {
  width: 88px;
  height: 36px;
  text-align: center;
  background-color: #e8e8e8;
}
.td-2 {
  width: 432px;
  height: 20px;
  padding: 8px 16px;
}
.article-block {
  width: 692px;
  min-height: 548px;
  background-color: #fff;
  padding: 24px 64px;
}
.module {
  line-height: 34px;
  padding-bottom: 8px;
  color: $titleFont;
}
.person-info {
  width: 520px;
}
.letter {
  margin-top: 10px;
}
.person {
  //   margin-top: 10px;
  display: grid;
  grid-template-columns: 33% 33% 33%;
  justify-items: center;
  //   height: 175px;
}
.person-img {
  //   margin-left: 24px;
  width: 150px;
  height: 188px;
  margin-top: 10px;
  margin-bottom: 8px;
  position: relative;
  cursor: pointer;
  img {
    width: 150px;
    height: 150px;
    position: absolute;
    top: 0;
    left: 0;
  }
  .img-name {
    width: 100%;
    height: 35px;
    line-height: 35px;
    text-align: center;
    // background: rgba(24, 24, 24, 0.5);
    position: absolute;
    color: #2f2f2f;
    font-size: 15px;
    left: 0;
    bottom: 0;
  }
}
</style>
